export const POSK_ROUTE = 'posk';
export const POSK_PAYMENT_PAGE = 'platnosc';
export const POSK_PAYMENT_CONFIRMATION = 'potwierdzenie';
export const POSK_PAYMENT_CONFIRMATION_PARAMETRIZED = 'potwierdzenie/:id';
